// PAPERLIKE CUSTOM — Paperlike-built, no vanilla equivalent

if(!window.customElements.get('variant-selector-modal')) {
  // Ported from live theme.js — vanilla theme.js does not expose formatMoney.
  function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }

  class VariantSelectorModal extends HTMLElement {
    constructor() {
      super();

      this.previousButton = this.querySelector(this.selectors.modalPrevious);
      this.continueBehaviour = this.dataset.continueBehaviour;
      this.continueButtonWrapper = this.querySelector(this.selectors.modalContinue);
      this.continueButton = this.querySelector(this.selectors.continueButton);
      
      this.productFormWrapper = this.querySelector(this.selectors.productFormWrapper);
      if(this.productFormWrapper) {
        this.addToCartButton = this.productFormWrapper.querySelector(this.selectors.addToCartButton);
      }
      
      this.emptyError = this.querySelector(this.selectors.emptyError);

      this.familyCardsWrapper = this.querySelector(this.selectors.familyCardsWrapper);
      this.modelCardsWrapper = this.querySelector(this.selectors.modelCardsWrapper);
      this.familyCards = this.querySelectorAll(this.selectors.familyCards);
      this.modelCards = this.querySelectorAll(this.selectors.modelCards);
      
      this.initModal();
      this.initFamilies();
      this.initModels();
    }

    connectedCallback() {
      document.addEventListener("variant:add", this.close.bind(this));
      this.attachKeyboardAccessibility();
    }

    selectors = {
      addToCartButton: '[type="submit"]',
      closeButton: '[data-close]',
      compareAtPrice: '.popup-modal__footer--price compare-at-price',
      continueButton: '[type="continue"]',
      emptyError: '.variant-selector__empty',
      familyCards: '[data-family-item]',
      familyCardsWrapper: '[data-family-items]',
      familySelection: '[data-family-selection]',
      fromElement: '.popup-modal__footer--pricing-label--from',
      modal: '.popup-modal__overlay--variant_selector_modal',     
      modalContainer: '.popup-modal--variant_selector_modal', 
      modalContinue: '[data-modal-continue]',
      modalPrevious: '[data-modal-previous]',
      modelCardsWrapper: '[data-model-items]',
      modelCards: '[data-model-item]',
      modelSelection: '[data-model-selection]',
      openButton: '[type="modal-trigger"]',
      productFormWrapper: '[data-modal-form-wrapper]',
      salePrice: '.popup-modal__footer--price sale-price',
      searchTrigger: '[data-search-trigger]',
      totalElement: '.popup-modal__footer--pricing-label--total',
      variantList: '.variant-selector__list',
      variantIdInput: 'input[name="id"]'
    }

    classes = {
      active: 'active',
      animated: 'section__animation-applied',
      complete: 'complete',
      hidden: 'hidden',
      largeText: 'text-lg',
      modalActive: 'variant-modal-active',
      saleText: 'text-on-sale',
      selected: 'selected',
      show: 'show',
      subdued: 'subdued',
      subduedBtn: 'button--subdued'
    }

    attributes = {
      disabled: 'disabled'
    }

    initModal() {
      this.modal = this.querySelector(this.selectors.modal);
      this.openButton = this.querySelector(this.selectors.openButton);
      this.closeButton = this.querySelector(this.selectors.closeButton);

      this.openButton?.addEventListener('click', () => this.open());
      this.closeButton?.addEventListener('click', () => this.close())

      if (this.continueBehaviour == 'continue_button') this.addClass(this.continueButton, this.classes.subduedBtn)
      if(this.addToCartButton) {
        this.addClass(this.addToCartButton, this.classes.subduedBtn)
        this.addToCartButton.setAttribute(this.attributes.disabled, this.attributes.disabled);
      }

      this.modalContainer = this.querySelector(this.selectors.modalContainer);
      const container = document.querySelector('[data-variant-selector-modal-container]');
      if (container && this.modalContainer && !container.contains(this.modalContainer)) {
        container.replaceChildren(this.modalContainer);
      }
    }

    initFamilies() {
      if(this.familyCards.length) {
        this.familyCards.forEach((card) => {
          card.addEventListener('click', () => this.handleFamilySelection(card));
        });
      }
      if (this.continueBehaviour == 'continue_button') this.initContinueButton();
    }

    handleFamilySelection(family) {
      this.selectedFamilyElement = family;
      this.familyCards.forEach((card) => {
        this.toggleClass(card, this.classes.selected, card === family);
        this.toggleClass(card, this.classes.subdued, card !== family);
      });
    
      const selectedFamily = family.dataset.family;
      this.visibleModels = Array.from(this.modelCards).filter((model) => model.dataset.family === selectedFamily);
      
      this.modelCards.forEach(model => {
        this.toggleClass(model, this.classes.hidden, !this.visibleModels.includes(model));
      });

      let lastIndex = 0;
      this.visibleModels.forEach((model, index) => {
        model.style.setProperty('--section-animate', (index + 1));
        lastIndex = index;
      });
      
      const searchTrigger = document.querySelector(this.selectors.searchTrigger);
      if (searchTrigger) {
        searchTrigger.style.setProperty('--section-animate', (lastIndex + 2));
      }

      this.toggleClass(this.emptyError, this.classes.show, this.visibleModels.length === 0);

      if (this.continueBehaviour == 'continue_button') {
        this.toggleClass(this.continueButton, this.classes.subduedBtn, false);
        this.continueButton?.removeAttribute(this.attributes.disabled);
        this.continueButton?.focus();
      } else {
        this.handleContinue(null);
      }

      this.handleStepChange(this.selectors.familySelection, selectedFamily, this.continueBehaviour != 'continue_button', true);
    }

    handleStepChange(selector, content, markComplete, markActive) {
      const step = document.querySelector(selector);
      console.log(step, markComplete)
      if (step) {
        if (content) step.innerText = content;
        if(markComplete) {
          console.log(step.parentNode)
          this.addClass(step.parentNode, this.classes.complete);
        } else {
          this.removeClass(step.parentNode, this.classes.complete);
        } 
        if(markActive) {
          this.addClass(step.parentNode, this.classes.active);
        } else {
          this.removeClass(step.parentNode, this.classes.active);
        }
      }
    }

    initContinueButton() {
      this.continueButton?.addEventListener('click', this.handleContinue.bind(this));
    }

    handleContinue(e) {
      if (e) e.preventDefault();
      this.handleStepChange(this.selectors.familySelection, null, true, true);
      this.handleStepChange(this.selectors.modelSelection, null, false, true);
      
      if (this.continueBehaviour == 'continue_button' && this.continueButtonWrapper) this.addClass(this.continueButtonWrapper, this.classes.hidden);
      if (this.productFormWrapper) this.removeClass(this.productFormWrapper, this.classes.hidden);

      if(this.familyCardsWrapper) {
        this.removeClass(this.familyCardsWrapper, this.classes.animated);
        this.removeClass(this.familyCardsWrapper.querySelector(this.selectors.variantList), this.classes.active); 
      }

      if(this.modelCardsWrapper) {
        this.addClass(this.modelCardsWrapper.querySelector(this.selectors.variantList), this.classes.active);
         setTimeout(() => {
          this.addClass(this.modelCardsWrapper, this.classes.animated);
        }, 200)
      }
      
      if(this.previousButton) this.initPreviousButton();

      const firstVisibleModel = 
        Array.from(this.modelCards).find(model => model.classList.contains(this.classes.selected)) ||
        Array.from(this.modelCards).find(model => !model.classList.contains(this.classes.hidden));
      if (firstVisibleModel) {
        firstVisibleModel.focus();
      } else {
        this.emptyError.focus();
      }
    }

    initPreviousButton() {
      this.previousButton.setAttribute('tabIndex', '0');
      this.addClass(this.previousButton, this.classes.show);
      this.previousButton.addEventListener('click', () => this.handlePrevious());
    }

    handlePrevious() {
      this.handleStepChange(this.selectors.familySelection, null, false, true);
      this.handleStepChange(this.selectors.modelSelection, themeVariables.strings.selectModel, false, false);
      this.modelCards.forEach((card) => {
        this.removeClass(card, this.classes.subdued);
        this.removeClass(card, this.classes.selected);
      });
      
      if (this.continueBehaviour == 'continue_button' && this.continueButtonWrapper) this.removeClass(this.continueButtonWrapper, this.classes.hidden);
      if (this.productFormWrapper) this.addClass(this.productFormWrapper, this.classes.hidden);

      if(this.familyCardsWrapper) {
        this.addClass(this.familyCardsWrapper.querySelector(this.selectors.variantList), this.classes.active);
        setTimeout(() => {
          this.addClass(this.familyCardsWrapper, this.classes.animated);
        }, 200);   
      }

      if(this.modelCardsWrapper) {
        this.addClass(this.modelCardsWrapper, this.classes.animated);
        this.removeClass(this.modelCardsWrapper.querySelector(this.selectors.variantList), this.classes.active);
      }
      this.removeClass(this.previousButton, this.classes.show);

      this.selectedFamilyElement?.focus();
      this.previousButton.removeAttribute('tabIndex');
    }

    initModels() {
      this.modelCards.forEach((card) => {
        card.querySelector('.variant-selector__card').addEventListener('click', () => this.handleModelSelection(card));
      });
    }

    handleModelSelection(model) {
      this.modelCards.forEach((card) => {
        this.toggleClass(card, this.classes.selected, card === model);
        this.toggleClass(card, this.classes.subdued, card !== model);
      });
      this.addClass(model, this.classes.selected);
      const selectedModel = model.dataset.model;
      const variantId = model.dataset.replacementVariantId || model.dataset.variantId;
      const variantPrice = model.dataset.variantPrice;
      const variantCompareAtPrice = model.dataset.variantCompareAtPrice;
      const variantTitle = model.dataset.variantTitle;
      const variantAvailable = model.dataset.replacementVariantId ? true : (model.dataset.variantAvailable == 'true');

      if (window.updatePdpShippingMessage) {
        window.updatePdpShippingMessage(variantId);
      }

      this.updateProductForm(variantId, variantAvailable);
      this.updateSessionStorage("selectedIpadSize", variantTitle);
      this.handleStepChange(this.selectors.modelSelection, selectedModel, true, true);
      this.updateVariantPrice(variantPrice, variantCompareAtPrice);
      this.addToCartButton.focus();
    }

    updateProductForm(variantId, available) {
      if (this.addToCartButton) {
        if (available) {
          this.removeClass(this.addToCartButton, this.classes.subduedBtn);
          this.addToCartButton.removeAttribute(this.attributes.disabled);
          this.addToCartButton.querySelector('div').innerText = themeVariables.strings.addToCartButton;
        } else {
          this.addClass(this.addToCartButton, this.classes.subduedBtn);
          this.addToCartButton.setAttribute(this.attributes.disabled, this.attributes.disabled);
          this.addToCartButton.querySelector('div').innerText = themeVariables.strings.soldOutButton;
        }
      }
      
      this.variantInput = this.productFormWrapper.querySelector(this.selectors.variantIdInput);
      if(this.variantInput && variantId) this.variantInput.value = variantId;
    }

    updateVariantPrice(variantPrice, variantCompareAtPrice) {
      this.toggleFromElement(false);

      this.currencyFormat = window.themeVariables.settings.currencyCodeEnabled
        ? window.themeVariables.settings.moneyWithCurrencyFormat
        : window.themeVariables.settings.moneyFormat;

      const priceElement = document.querySelector(this.selectors.salePrice);
      const compareAtPriceElement = document.querySelector(this.selectors.compareAtPrice);
      if (priceElement) {
        const formattedPrice = formatMoney(variantPrice, this.currencyFormat);
        if (priceElement.textContent.trim() !== formattedPrice) {
          priceElement.lastChild.replaceWith(document.createRange().createContextualFragment(formattedPrice));
        }
        this.toggleClass(priceElement, this.classes.saleText, variantCompareAtPrice > variantPrice);
      }

      if (compareAtPriceElement) {
        const formattedCompareAtPrice = formatMoney(variantCompareAtPrice, this.currencyFormat);
        if (compareAtPriceElement.textContent.trim() !== formattedCompareAtPrice) {
          compareAtPriceElement.lastChild.replaceWith(document.createRange().createContextualFragment(formattedCompareAtPrice));
        }
        compareAtPriceElement.hidden = !(variantCompareAtPrice > variantPrice);
        this.addClass(compareAtPriceElement, this.classes.largeText);
      }
    }

    toggleFromElement(show) {
      const fromElement = document.querySelector(this.selectors.fromElement);
      const totalElement = document.querySelector(this.selectors.totalElement);
      if (fromElement) {
        this.toggleClass(fromElement, this.classes.hidden, !show);
        this.toggleClass(totalElement, this.classes.hidden, show);
      }
    }
    
    updateSessionStorage(key, value) {
      localStorage.setItem(key, value);
    }

    toggleModal(open) {
      this.toggleClass(document.body, this.classes.modalActive, open);
      this.modal.style.display = open ? 'flex' : 'none';

      // Add or remove the data attribute based on the open state
      if (open) {
        this.modal.setAttribute('data-is-open', '');
         // Use requestAnimationFrame to apply the transition class after the display change
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this.addClass(this.modal, 'is-visible'); // Add your transition class
            });
          });
      } else {
        this.modal.removeAttribute('data-is-open');
        this.removeClass(this.modal, 'is-visible');
      }
      
      this.firstOption = this.querySelector(this.selectors.familyCards);
      
      if (open) {
        this.handlePrevious();
        this.addClass(this.familyCardsWrapper, this.classes.animated);
        // this.firstOption?.focus();
        document.addEventListener("keydown", this.handleEscapeKey.bind(this));
      } else {
        this.openButton?.focus();
        document.removeEventListener("keydown", this.handleEscapeKey.bind(this));
        this.resetModal();

        if (window.resetPdpShippingMessage) {
          window.resetPdpShippingMessage();
        }
      }
    }
    
    open() {
      this.toggleModal(true);
    }
    
    close() {
      this.toggleModal(false);
    }

    resetModal() {
     if(this.addToCartButton) {
        this.addClass(this.addToCartButton, this.classes.subduedBtn)
        this.addToCartButton.setAttribute(this.attributes.disabled, this.attributes.disabled);
      }
      this.handleStepChange(this.selectors.familySelection, themeVariables.strings.selectFamily, false, true);
      this.handleStepChange(this.selectors.modelSelection, themeVariables.strings.selectModel, false, false);
      this.familyCards.forEach((card) => {
        this.removeClass(card, this.classes.selected);
        this.removeClass(card, this.classes.subdued);
      });
      this.toggleFromElement(true);
    }
    
    handleEscapeKey(event) {
      if (event.key === "Escape") this.close();
    }

    attachKeyboardAccessibility() {
      const handleVariantSelection = (event) => {
        if (event.type === "click" || event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          event.target.click();
        }
      };
  
      const attachListeners = (selector) => {
        this.querySelectorAll(selector).forEach((item) => {
          item.addEventListener("keydown", handleVariantSelection);
        });
      };
  
      attachListeners(this.selectors.familyCards);
      attachListeners(this.selectors.modelCards);
      attachListeners(this.selectors.modalPrevious);
    }

    addClass(el, name) {
      el?.classList.add(name);
    }

    removeClass(el, name) {
      el?.classList.remove(name);
    }

    toggleClass(el, name, condition) {
      el?.classList.toggle(name, condition);
    }
  };
  
  window.customElements.define('variant-selector-modal', VariantSelectorModal);
}

if (!window.customElements.get('variant-model-search')) {
  class VariantModelSearch extends HTMLElement {
    constructor() {
      super();
      this.firstGo = true;
      
      this.content = this.querySelector(this.selectors.content);
      this.searchInput = this.querySelector(this.selectors.searchInput);
      this.modelsJson = JSON.parse(this.querySelector(this.selectors.modelsJson)?.textContent)?.models || [];
      this.searchResults = this.querySelector(this.selectors.searchResults);
      this.searchResultItems = this.querySelectorAll(this.selectors.searchResultItems);
      this.skeleton = this.querySelector(this.selectors.skeleton);
      this.emptyState = this.querySelector(this.selectors.emptyState);
      this.productForms = this.querySelectorAll('.shopify-product-form');
      this.initModal()
    }

    connectedCallback() {
      document.addEventListener("variant:add", this.close.bind(this));
    }

    selectors = {
      modal: '.popup-modal__overlay--search',
      openButton: '[data-search-trigger]',
      closeButton: '[data-close]',
      content: '.variant-selector__content',
      searchInput: '#ModelSearch',
      modelsJson: '[data-models]',
      searchResults: '.variant-selector__search--results',
      searchResultItems: '.variant-selector__search--result',
      skeleton: '.loading-skeleton',
      emptyState: '.empty-state',
    }

    classes = {
      active: 'active',
      animated: 'section__animation-applied',
      complete: 'complete',
      hidden: 'hidden',
      modalActive: 'variant-modal-active',
      selected: 'selected',
      show: 'show',
    }

    initModal() {
      this.modal = this.querySelector(this.selectors.modal);
      this.openButton = document.querySelector(this.selectors.openButton);
      this.closeButton = this.querySelector(this.selectors.closeButton);

      this.openButton?.addEventListener('click', () => this.open());
      this.closeButton?.addEventListener('click', () => this.close());
      
      this.searchInput?.addEventListener('input', () => this.handleSearch());

      if (this.productForms.length > 0) {
        this.productForms.forEach((form) => form.addEventListener('submit', () => this.updateSessionStorage("selectedIpadSize", form.dataset.model)));
      }
    }

    handleSearch() {
      this.searchResultItems.forEach((item) => {
        item.style.display = "none";
      });
      
      if (this.searchInput.value === '') {
        this.firstGo = true;
        this.searchResults.style.display = 'none';
        this.skeleton.style.display = 'grid';
        return;
      } else {
        this.searchResults.style.display = 'block';
      }

      if(this.firstGo) {
        this.firstGo = false;
        setTimeout(() => {
          this.filterModels(this.searchInput.value);
        }, 500);
      } else {
        this.filterModels(this.searchInput.value);
      }
    }

    filterModels(value) {
      let sanitisedValue = value.toLowerCase();
      this.skeleton.style.display = 'none';
          
      const results = this.modelsJson.filter((model) =>
        model.model_numbers.some((num) => num.includes(sanitisedValue))
      );
      
      if (results.length > 0) {
        this.emptyState.style.display = 'none';
        results.forEach((model) =>  {
          document.querySelectorAll(`[data-model="${model.name}"`)?.forEach((result) => result.style.display = 'flex');
        })
      } else {
        this.emptyState.style.display = 'flex';
      }
    }

    updateSessionStorage(key, value) {
      localStorage.setItem(key, value);
    }

    toggleModal(open) {
      // not needed on search modal -> this.toggleClass(document.body, this.classes.modalActive, open);
      this.modal.style.display = open ? 'flex' : 'none';

      // Add or remove the data attribute based on the open state
      if (open) {
        this.modal.setAttribute('data-is-open', '');
         // Use requestAnimationFrame to apply the transition class after the display change
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this.addClass(this.modal, 'is-visible'); // Add your transition class
            });
          });
      } else {
        this.modal.removeAttribute('data-is-open');
        this.removeClass(this.modal, 'is-visible');
      }
      
      if (open) {
        this.addClass(this.content, this.classes.animated);
        // Focus input field
        // this.searchInput.focus();
        document.addEventListener("keydown", this.handleEscapeKey.bind(this));
      } else {
        console.log(this.openButton)
        this.openButton?.focus();
        this.searchInput.value = '';
        this.firstGo = true;
        this.searchResults.style.display = 'none';
        this.skeleton.style.display = 'grid';
        document.removeEventListener("keydown", this.handleEscapeKey.bind(this));
      }
    }
    
    open() {
      this.toggleModal(true);
    }
    
    close() {
      this.toggleModal(false);
    }
    
    handleEscapeKey(event) {
      if (event.key === "Escape") this.close();
    }

    addClass(el, name) {
      el?.classList.add(name);
    }

    removeClass(el, name) {
      el?.classList.remove(name);
    }

    toggleClass(el, name, condition) {
      el?.classList.toggle(name, condition);
    }
  }

  window.customElements.define('variant-model-search', VariantModelSearch)
}

if (!window.customElements.get('variant-selector-modal-trigger')) {
  window.customElements.define('variant-selector-modal-trigger', class VariantSelectorModalTrigger extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      this.variantSelectorModal = document.querySelector('variant-selector-modal');
    }

    connectedCallback() {
      if (this.button) {
        this.button.addEventListener('click', () => {
          this.variantSelectorModal.toggleModal(true);
        });
      }
    }
  })
}

